import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Grid,
  TextField,
  Button,
  Autocomplete,
  Box,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";

function Sidebar() {
  const navigate = useNavigate();
  const products = ["HRMS", "CRM", "ERP"];

  const [selectedProducts, setSelectedProducts] = React.useState([]);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);

  const handleNewSubscribe = () => {
    navigate("/products");
  };

  return (
    <Card sx={{ p: 3, mb: 2 }} elevation={4}>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Autocomplete
            multiple
            options={products}
            value={selectedProducts}
            onChange={(event, newValue) => setSelectedProducts(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Product Name" />
            )}
            fullWidth
          />
        </Grid>

        <Grid item>
          <TextField
            select
            label="Status"
            fullWidth
            SelectProps={{ native: true }}
          >
            <option value="active">Select</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="expired">Expired</option>
          </TextField>
        </Grid>
        <Grid item>
          <TextField
            select
            label="Filter By"
            fullWidth
            SelectProps={{ native: true }}
          >
            <option value="active">Select</option>
            <option value="active">Subscribed/Renewed On</option>
            <option value="active">Transaction</option>
            <option value="inactive">Expiry</option>
          </TextField>
        </Grid>
        <Grid item>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
              format="dd/MM/yyyy"
                label="From"
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Box>
        </Grid>

        <Grid item>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
              format="dd/MM/yyyy"
                label="To"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Box>
        </Grid>
        <Grid item>
          <TextField
            select
            label="Transaction Mode"
            fullWidth
            SelectProps={{ native: true }}
          >
            <option value="active">Select</option>
            <option value="active">Cash</option>
            <option value="inactive">Card</option>
          </TextField>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            fullWidth
            sx={{
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              color: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              textTransform: "uppercase",
              fontWeight: "bold",
              "&:hover": {
                background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

export default Sidebar;
